import { useTheme } from "@mui/material/styles";

export function CheckMarkIcon() {
  const { palette } = useTheme();
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7.8L5.9 12.2L15 1"
        stroke={palette.primary.main}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
